
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bqp2a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44336a9c4a8d1ba1d89b8770fe0f43de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85158aa860f7f38a$var$_react = $85158aa860f7f38a$var$_interopRequireDefault((parcelRequire("42omo")));

var $85158aa860f7f38a$var$_baseNew = $85158aa860f7f38a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $85158aa860f7f38a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPreviousOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-previous-overlay
 * Usage guidance:
 * Single purpose - Reserved for previous video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85158aa860f7f38a$var$VideoPreviousOverlayIcon = (props)=>/*#__PURE__*/ $85158aa860f7f38a$var$_react.default.createElement($85158aa860f7f38a$var$_baseNew.default, Object.assign({
        name: "VideoPreviousOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1v14h1.5V8.708c.147.336.404.633.77.831l6.148 3.323A1.75 1.75 0 0 0 14 11.322V4.678a1.75 1.75 0 0 0-2.582-1.54L5.27 6.462a1.73 1.73 0 0 0-.771.83V1z" clip-rule="evenodd"/>`
    }, props));
$85158aa860f7f38a$var$VideoPreviousOverlayIcon.displayName = 'VideoPreviousOverlayIcon';
var $85158aa860f7f38a$var$_default = module.exports.default = $85158aa860f7f38a$var$VideoPreviousOverlayIcon;

});


//# sourceMappingURL=video-previous-overlay.a5089076.js.map
